import { StyledAppLottie } from "./index.styled";
import PropTypes from "prop-types";

const AppLottie = (props) => {
  const { animationData, className, size, loop } = props;

  const lottieSize = typeof size === "number" ? `${size}px` : size;
  return (
    <StyledAppLottie
      className={className}
      animationData={animationData}
      loop={loop}
      size={lottieSize}
    />
  );
};

AppLottie.propTypes = {
  animationData: PropTypes.object.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loop: PropTypes.bool,
};

AppLottie.defaultProps = {
  loop: false,
  size: "auto",
  className: "",
};

export default AppLottie;
